export const CandidateAccountConst = {
  Expansions: {
    PracticeAreaInfo: 'practiceAreaInfo',
  },
} as const;
